import {
  Award, BadgeCheck, BellRing, Building2, Cctv, CircleDot, ClipboardCheck, Clock, Cpu, DoorOpen, Droplets, Factory,
  FileCheck2, Fingerprint, FireExtinguisher, Flame, GraduationCap, HardHat, HeartHandshake, Hotel, House, Megaphone,
  PencilRuler, Ruler, ScanFace, ShieldCheck, ShowerHead, Siren, Sparkles, Target, TrendingDown, TriangleAlert,
  UsersRound, Waves, Wind, Wrench,
} from 'lucide-react';

/** Lucide icons the CMS can pick by name. Keep in sync with ICON_NAMES in site/content/schema.js. */
export const icons = {
  award: Award,
  'badge-check': BadgeCheck,
  'bell-ring': BellRing,
  'building-2': Building2,
  cctv: Cctv,
  'clipboard-check': ClipboardCheck,
  clock: Clock,
  cpu: Cpu,
  'door-open': DoorOpen,
  droplets: Droplets,
  factory: Factory,
  'file-check-2': FileCheck2,
  fingerprint: Fingerprint,
  'fire-extinguisher': FireExtinguisher,
  flame: Flame,
  'graduation-cap': GraduationCap,
  'hard-hat': HardHat,
  'heart-handshake': HeartHandshake,
  hotel: Hotel,
  house: House,
  megaphone: Megaphone,
  'pencil-ruler': PencilRuler,
  ruler: Ruler,
  'scan-face': ScanFace,
  'shield-check': ShieldCheck,
  'shower-head': ShowerHead,
  siren: Siren,
  sparkles: Sparkles,
  target: Target,
  'trending-down': TrendingDown,
  'triangle-alert': TriangleAlert,
  'users-round': UsersRound,
  waves: Waves,
  wind: Wind,
  wrench: Wrench,
};

export default function Icon({ name, className = 'h-5 w-5', ...props }) {
  const Component = icons[name] || CircleDot;
  return <Component className={className} aria-hidden="true" {...props} />;
}
